module.exports = __webpack_public_path__ + "static/media/mulcahy.a641b814.png";